import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'sc-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true
    }
  ]
})
export class CheckboxComponent implements ControlValueAccessor {
  @Input() disabled = false;
  @Input() name: string;
  @Input() options: {
    truthy: string;
    falsy: string;
  };

  public checked = false;

  onChange = (checked: string) => {};
  onTouched = () => {};

  check(value: boolean) {
    if (!this.disabled) {
      this.writeValue(value);
    }
  }

  writeValue(checked: string | boolean) {
    this.checked = typeof checked === 'boolean' ? checked : this.options.truthy === checked;
    this.onChange(this.checked ? this.options.truthy : this.options.falsy);
  }

  registerOnChange(fn: () => void): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
